import axios from 'utils/axios';

const API_URL = 'qpQuestionBank';

export const addAssessmentQue = async (data: any) => {
  return await axios.post(API_URL + '/', data);
};

export const bulkCreate = async (data: any) => {
  return await axios.post(API_URL + '/bulkCreate', data);
};

export const bulkUpsert = async (data: any) => {
  return await axios.post(API_URL + '/bulkUpsert', data);
};

export const getByAssessmentTemplateId = async (assessmentSessionId: string) => {
  return await axios.get(API_URL, { params: { assessmentSessionId } });
};
